// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Public Sans",-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  -moz-osx-font-smoothing: grayscale;
}
 *{
  font-family: "Inter";
  box-sizing: border-box;
}
@media screen and (max-width: 768px) {
  body {
    font-size: 15px;
  }
}
@media screen and (max-width: 480px) {
  body {
    font-size: 14px;
  }
}
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

/* Hide scrollbar by default */  
div {  
  scrollbar-width: none; /* For Firefox */  
  -ms-overflow-style: none; /* For Internet Explorer and Edge */  
}  

div::-webkit-scrollbar {  
  display: none; /* For Chrome, Safari, and Opera */  
}  

/* Show scrollbar on hover */  
div:hover {  
  scrollbar-width: thin; /* For Firefox */  
  -ms-overflow-style: auto; /* For Internet Explorer and Edge */  
}  

div:hover::-webkit-scrollbar {  
  display: block; /* For Chrome, Safari, and Opera */  
  width: 5px;  
  height: 5px;  
}  

/* Scrollbar styles */  
div:hover::-webkit-scrollbar-track {  
  background: transparent;  
  margin-top: 10%;  
  margin-bottom: 10%;  
  border-radius: 3px;  
}  

div:hover::-webkit-scrollbar-thumb {  
  background: #d7d7d7;  
  border-radius: 3px;  
}  

div:hover::-webkit-scrollbar-thumb:hover {  
  background: #08225f;  
}

/* Apply styles to the title attribute tooltip */
[tooltip]::after {
  content: attr(title);
  display: block;
  position: absolute;
  padding: 10px;
  background-color: #333;
  color: #fff;
  border-radius: 5px;
  z-index: 9999;
  /* Adjust positioning to ensure full visibility */
  bottom: 100%; /* Show above the element */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

/* Show the tooltip on hover */
[tooltip]:hover::after {
  opacity: 1;
  visibility: visible;
}


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,4KAA4K;EAC5K,mCAAmC;EACnC,eAAe;EACf,kCAAkC;AACpC;CACC;EACC,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,+EAA+E;AACjF;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB,EAAE,gBAAgB;EACvC,wBAAwB,EAAE,mCAAmC;AAC/D;;AAEA;EACE,aAAa,EAAE,kCAAkC;AACnD;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB,EAAE,gBAAgB;EACvC,wBAAwB,EAAE,mCAAmC;AAC/D;;AAEA;EACE,cAAc,EAAE,kCAAkC;EAClD,UAAU;EACV,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,iDAAiD;EACjD,YAAY,EAAE,2BAA2B;EACzC,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA,8BAA8B;AAC9B;EACE,UAAU;EACV,mBAAmB;AACrB","sourcesContent":["body {\n  margin: 0;\n  font-family: \"Public Sans\",-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-size: 16px;\n  -moz-osx-font-smoothing: grayscale;\n}\n *{\n  font-family: \"Inter\";\n  box-sizing: border-box;\n}\n@media screen and (max-width: 768px) {\n  body {\n    font-size: 15px;\n  }\n}\n@media screen and (max-width: 480px) {\n  body {\n    font-size: 14px;\n  }\n}\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n/* Hide scrollbar by default */  \ndiv {  \n  scrollbar-width: none; /* For Firefox */  \n  -ms-overflow-style: none; /* For Internet Explorer and Edge */  \n}  \n\ndiv::-webkit-scrollbar {  \n  display: none; /* For Chrome, Safari, and Opera */  \n}  \n\n/* Show scrollbar on hover */  \ndiv:hover {  \n  scrollbar-width: thin; /* For Firefox */  \n  -ms-overflow-style: auto; /* For Internet Explorer and Edge */  \n}  \n\ndiv:hover::-webkit-scrollbar {  \n  display: block; /* For Chrome, Safari, and Opera */  \n  width: 5px;  \n  height: 5px;  \n}  \n\n/* Scrollbar styles */  \ndiv:hover::-webkit-scrollbar-track {  \n  background: transparent;  \n  margin-top: 10%;  \n  margin-bottom: 10%;  \n  border-radius: 3px;  \n}  \n\ndiv:hover::-webkit-scrollbar-thumb {  \n  background: #d7d7d7;  \n  border-radius: 3px;  \n}  \n\ndiv:hover::-webkit-scrollbar-thumb:hover {  \n  background: #08225f;  \n}\n\n/* Apply styles to the title attribute tooltip */\n[tooltip]::after {\n  content: attr(title);\n  display: block;\n  position: absolute;\n  padding: 10px;\n  background-color: #333;\n  color: #fff;\n  border-radius: 5px;\n  z-index: 9999;\n  /* Adjust positioning to ensure full visibility */\n  bottom: 100%; /* Show above the element */\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease, visibility 0.3s ease;\n}\n\n/* Show the tooltip on hover */\n[tooltip]:hover::after {\n  opacity: 1;\n  visibility: visible;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
